/** yyyy-mm-dd in the browser's local calendar (matches Vuetify :max="today" fields). */
export function localTodayYmd() {
  return toLocalYmd(new Date());
}

function toLocalYmd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * How far back every list screen's main date filter starts ("last one month").
 * Keep in step with DEFAULT_RANGE_DAYS in app-js/karrofin/config.js and
 * RANGE_DAYS in cashpo-server helper/management/commands/refresh_panel_caches.py.
 */
export const DEFAULT_FILTER_DAYS = 30;

/**
 * Local yyyy-mm-dd strings for the primary signup date filter:
 * from (today − daysBack) through today.
 */
export function getDefaultSignupDateRangeIso(daysBack = DEFAULT_FILTER_DAYS) {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - daysBack);
  return [toLocalYmd(start), toLocalYmd(end)];
}

/** Same display string as list pages' formateDisplayDateRange (dd-mm-yyyy to dd-mm-yyyy). */
export function formatSignupDateRangeDisplay(dateRange) {
  if (!dateRange || dateRange.length < 2) return "";
  let date1 = dateRange[0];
  let date2 = dateRange[1];
  let to;
  let from;
  if (date1 > date2) {
    to = date1;
    from = date2;
  } else {
    to = date2;
    from = date1;
  }
  if (!to) to = from;
  const fmt = (d) => {
    const [year, month, day] = d.split("-");
    return `${day}-${month}-${year}`;
  };
  return `${fmt(from)} to ${fmt(to)}`;
}
